import React, { PureComponent } from "react";
import * as Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { numberWithCommas, kmFormatter } from "../utils";
import HighchartsCustomEvents from "highcharts-custom-events";

HighchartsCustomEvents(Highcharts);
class MomentChart extends PureComponent {
    chartComponent = React.createRef();
    state = {};

    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    getPieOptions = () => {
        let chartConfig = {};

        let self = this;

        let total = this.props.data.total;

        let chartData = this.props.data.chartDonutData;

        chartConfig = {
            chart: {
                type: "pie",
                className: "skiptranslate",
                backgroundColor: "transparent",
                spacingTop: 0,
                spacingBottom: 5,
                spacingLeft: 0,
                spacingRight: 0,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
                margin: [10],
            },
            title: {
                text: ``,
            },

            credits: {
                enabled: false,
            },
            plotOptions: {
                pie: {
                    shadow: false,
                    borderWidth: 0,
                    showInLegend: true,

                    dataLabels: {
                        enabled: this.props.showLabel,
                        distance: "10%",
                        format: "{point.name}: {point.percentage:.1f} %",
                        style: {
                            fontWeight: 400,
                            textOutline: "none",
                        },
                        padding: 0,
                    },

                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },
            legend: {
                enabled: this.props.hideLegend,
                itemStyle: {
                    fontWeight: 400,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: false,
                margin: 0,
                align: "center",
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },

            series: [
                {
                    name: "Moment Analysis",
                    data: chartData,
                },
            ],
            tooltip: {
                followPointer: true,
                followTouchMove: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                valueSuffix: "%",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                },
                formatter: function () {
                    return `<b>${this.point.name} | ${this.point.percentage.toFixed(1) + "%"} | ${numberWithCommas(this.point.y)}/${numberWithCommas(
                        total,
                    )} </b>`;
                },
            },
        };
        return chartConfig;
    };

    getBarOptions = () => {
        let breaks = new Map();
        let self = this;

        let total = this.props.data.total;
        let chartData = JSON.parse(JSON.stringify(this.props.data));

        if (this.props.expandWidget) {
            if (this.props.data.maximizeBar) {
                chartData = [...chartData.chartBarData, ...chartData.maximizeBar];
            } else {
                chartData = [...chartData.chartBarData, ...chartData.othersBar];
            }
        } else {
            chartData = [...chartData.chartBarData, ...chartData.othersBar];
        }
        let heightOfScrollBar = chartData.length * 20;
        const options = {
            chart: {
                type: "bar",
                align: "center",
                backgroundColor: "transparent",
                scrollablePlotArea: {
                    minHeight: heightOfScrollBar,
                    opacity: 1,
                },
            },
            title: {
                text: " ",
            },
            credits: {
                enabled: false,
            },
            legend: {
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: false,

                enabled: this.props.hideLegend,
                width: "20%",
                layout: "vertical",
                align: "right",
                padding: 10,

                itemMarginTop: 3,
                itemMarginBottom: 3,
                verticalAlign: "middle",
                labelFormatter: function () {
                    return `<p>${this.name}</p><br/>`;
                },
            },
            xAxis: {
                type: "category",

                labels: {
                    align: "center",

                    style: {
                        textOverflow: "ellipsis",
                    },
                },
                lineWidth: 1,
            },

            yAxis: {
                min: 0,
                title: "",
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                labels: {
                    align: "center",
                },
            },

            tooltip: {
                followPointer: true,
                followTouchMove: true,
                backgroundColor: "#fff",
                borderRadius: 6,
                style: {
                    fontFamily: "'Roboto', sans-serif",
                },

                formatter: function () {
                    return `<b>${this.series.userOptions.name} | ${((this.y * 100) / total).toFixed(1) + "%"} | ${numberWithCommas(this.y)}/${numberWithCommas(
                        total,
                    )} </b>`;
                },
            },

            plotOptions: {
                column: {
                    grouping: false,
                    pointPadding: 15,
                    borderWidth: 0,
                },
                series: {
                    //   events: {
                    //    legendItemClick: function () {
                    //             //                             var seriesIndex = this.index;
                    //             // var series = this.chart.series;
                    //             // if (this.visible && this.chart.restIsHidden) {
                    //             //   for (var i = 0; i < series.length; i++) {
                    //             //     if (series[i].index != seriesIndex) {
                    //             //       series[i].show();
                    //             //     }
                    //             //   }
                    //             //   this.chart.restIsHidden = false;
                    //             // } else {
                    //             //   for (var i = 0; i < series.length; i++) {
                    //             //     if (series[i].index != seriesIndex) {
                    //             //       series[i].hide();
                    //             //     }
                    //             //   }
                    //             //   this.show()
                    //             //   this.chart.restIsHidden = true;
                    //             // }
                    //             // return false;

                    //             // var seriesIndex = this.index;
                    //             // var series = this.chart.series;

                    //             // for (var i = 0; i < series.length; i++) {
                    //             //     if (series[i].index != seriesIndex) series[i].show();
                    //             //     else series[i].hide();
                    //             // }
                    //             // return false;
                    //             console.log("++++", this);
                    //             if (breaks.has(this.xData[0])) {
                    //                 breaks.delete(this.xData[0]);
                    //             } else {
                    //                 breaks.set(this.xData[0], { from: this.xData[0] - 0.5, to: this.xData[0] + 0.5, breakSize: 0 });
                    //             }

                    //             console.log(this.chart.xAxis[0]);

                    //             this.chart.xAxis[0].update(
                    //                 {
                    //                     breaks: [...breaks.values()],
                    //                 },
                    //                 true,
                    //             );
                    //   },
                    //  },
                    pointWidth: 15,
                    stacking: "normal",
                    dataLabels: { enabled: true },
                },

                bar: {
                    borderWidth: 0,
                    shadow: false,
                    showInLegend: true,
                    dataLabels: {
                        enabled: this.props.showLabel,
                        formatter: function () {
                            return `<span>${kmFormatter(this.point.y)}</span>
                            `;
                        },
                        inside: false,
                        style: {
                            color: "#333333",
                            textOutline: "none",
                        },

                        pointWidth: 15,
                        stacking: "normal",
                    },
                    point: {
                        events: {
                            contextmenu: function (e) {
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                    events: {
                        legendItemClick: function () {
                            if (this.visible) {
                                this.setData([], false);
                            } else {
                                this.setData(chartData[this.index].data, false);
                            }
                        },
                    },
                },
            },
            series: chartData,
        };
        return options;
    };

    render() {
        return (
            <>
                {this.props.graph_type === "pie" && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getPieOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "100%" } }}
                    />
                )}
                {this.props.graph_type === "bar" && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={this.getBarOptions()}
                        ref={this.chartComponent}
                        containerProps={{ style: { width: "100%", height: "100%" } }}
                    />
                )}
            </>
        );
    }
}

export default MomentChart;
